"use client";
import Image from "next/image";
import { useEffect, useRef } from "react";

const TextInput = (props: any) => {
  const {
    clearClicked,
    handleClearComplete,
    cls,
    placeholder,
    label,
    onChange,
    errorMessage,
    isSearch,
    isNumber,
    isNoBorderLeft,
    isNoBorderRight,
    width,
    onSearchClick,
    initialValue,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const handleKeyDown = (e: any) => {
    if (isNumber && e.key === "-") {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      e.preventDefault();
      onSearchClick();
    }
  };

  const handlePaste = (e: any) => {
    const pastedText = e.clipboardData.getData("text");
    if (isNumber && pastedText.includes("-")) {
      e.preventDefault();
    }
  };

  const handleClear = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    if (clearClicked) {
      handleClearComplete();
    }
  };

  useEffect(() => {
    if (clearClicked) {
      handleClear();
    }
  }, [clearClicked]);

  return (
    <>
      <div className={`relative inline-block ${width}`}>
        <p className="bdy-txt-5 mb-2">{label}</p>
        <div className="relative">
          <input
            ref={inputRef}
            type={isNumber ? "number" : "text"}
            min={0}
            placeholder={placeholder}
            className={` search-input border border-solid border-black py-1.5 px-4 w-full h-[50px] outline-none ${cls} ${
              isNumber ? "xl:pb-[8px]" : ""
            }${isNoBorderLeft ? " xl:border-l-0 " : ""}
              ${isNoBorderRight ? "xl:border-r-0" : ""}`}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            value={initialValue}
          />
          {isSearch && (
            <div
              className="absolute inset-y-0 right-4 flex items-center"
              onClick={onSearchClick}
            >
              <Image
                width={180}
                height={37}
                alt="test"
                className="w-full card-image hover:scale-110 transition duration-500 cursor-pointer"
                src="/assets/icons/search.svg"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default TextInput;
